module.exports = __webpack_public_path__ + "static/media/PRIL.88320553.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/maxsizeimages/books/PRIL.jpg
// module id = 1773
// module chunks = 1